<div class="information-clause">
  <div class="information-clause__wrapper" *ngIf="!expandSectionMode || expanded">
    <ng-container *ngFor="let paragraph of paragraphs">
      <p [innerHTML]="paragraph.path | translate: true: paragraph.params | safeHtml"></p>
    </ng-container>
  </div>
  <div class="information-clause__wrapper" *ngIf="expandSectionMode && !expanded">
    <p [innerHTML]="translationsContainer + '.collapsedText' | translate | safeHtml"></p>
    <div *ngIf="!expanded" (click)="expandContent()" class="container--edit-button">
      <label> {{ translationsContainer + '.expandBtn' | translate}} </label>
      <mat-icon>arrow_right</mat-icon>
    </div>
  </div>
</div>
